module.exports = __webpack_public_path__ + "media/images/3DModelIcon-01-80007f06.png";